import { gql, graphql } from "react-apollo"
import { GetUsersQuery } from "./withUsers"
import type { User } from "../types"

const MUTATE_CREATE_USER = gql`
  mutation CreateUser($user: UserInput!) {
    createUser(user: $user) {
      id
      name
      email
      admin
    }
  }
`

const mutateCreateUser = graphql(MUTATE_CREATE_USER, {
  name: "mutateCreateUser",
  options: {
    refetchQueries: [{ query: GetUsersQuery, variables: { query: "" } }]
  },
  props: ({ mutateCreateUser }) => ({
    createUser: ({ name, email, admin, password }: User) =>
      mutateCreateUser({
        variables: { user: { name, email, admin, password } }
      })
  })
})

export default mutateCreateUser



// WEBPACK FOOTER //
// ./src/Users/queries/mutateCreateUser.js